// Shared recording-phase visuals for the interview flow. Extracted from
// ConsentGate so ConsentGate and FinalConsentRecording reuse the same pulses
// instead of duplicating the markup. (QuestionFlow keeps its own inline pulses
// — its idle state has no icon — and is intentionally left untouched here.)

import { Mic } from "lucide-react";

export const SpeakerPulse = () => (
  <div className="mx-auto flex h-24 w-24 items-center justify-center">
    <span className="relative flex h-24 w-24">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary/30" />
      <span className="relative inline-flex h-24 w-24 items-center justify-center rounded-full bg-primary/70">
        <svg viewBox="0 0 24 24" className="h-12 w-12 text-primary-foreground" fill="currentColor">
          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4.03v8.05A4.5 4.5 0 0 0 16.5 12z" />
        </svg>
      </span>
    </span>
  </div>
);

export const RecordingPulse = () => (
  <div className="mx-auto flex h-24 w-24 items-center justify-center">
    <span className="relative flex h-24 w-24">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-destructive/40" />
      <span className="relative inline-flex h-24 w-24 items-center justify-center rounded-full bg-destructive">
        <Mic className="h-12 w-12 text-destructive-foreground" />
      </span>
    </span>
  </div>
);
